/* Choose your device — Simply Carbon Fiber (2026-09-18, drawer 2026-09-19). sections/device-chips.liquid + assets/scf-device.css
   Opens the drawer (left on desktop, full screen on phones), switches family tabs. Model links are real hrefs,
   so choosing works without JavaScript; this only adds the drawer. */
(function () {
  'use strict';
  function q(s, r) { return (r || document).querySelector(s); }
  function all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function isPhone() { return window.matchMedia('(max-width: 768px)').matches; }
  function root() { return q('[data-scf-dev]'); }
  function lock(on) { document.documentElement.classList.toggle('scf-dev-lock', !!on); }

  function isOpen() { var p = q('[data-scf-dev-pan]'); return p && !p.hidden; }
  function open() {
    var r = root(), p = q('[data-scf-dev-pan]', r), o = q('.scf-dev__ovl', r);
    if (!p) return;
    /* a phone shows one family at a time: the chosen device's family, or the first */
    if (!q('.scf-dev__fam.is-cur', p)) {
      var f = q('.scf-dev__fam', p), t = q('[data-scf-dev-tab]', p);
      if (f) f.classList.add('is-cur');
      if (t) t.classList.add('is-cur');
    }
    p.hidden = false; if (o) o.hidden = false;
    all('[data-scf-dev-open]', r).forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    lock(true);   /* the drawer covers the page on every size now (left drawer on desktop, full screen on phones) */
    var x = q('[data-scf-dev-close]', p); if (x && !isPhone()) x.focus({ preventScroll: true });
  }
  function close() {
    var r = root(); if (!r) return;
    var p = q('[data-scf-dev-pan]', r), o = q('.scf-dev__ovl', r);
    if (p) p.hidden = true; if (o) o.hidden = true;
    all('[data-scf-dev-open]', r).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    lock(false);
  }
  var guardUntil = 0;
  function showFamily(key) {
    var r = root();
    guardUntil = Date.now() + 350; /* a slipped second tap right after switching tabs must not pick a model */
    all('.scf-dev__fam', r).forEach(function (f) { f.classList.toggle('is-cur', f.dataset.scfDevFam === key); });
    all('[data-scf-dev-tab]', r).forEach(function (t) { t.classList.toggle('is-cur', t.dataset.scfDevTab === key); });
    var cols = q('.scf-dev__cols', r); if (cols) cols.scrollTop = 0;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-scf-dev-open], [data-scf-dev-close], [data-scf-dev-tab], [data-scf-dev-more]');
    if (t) {
      if (t.hasAttribute('data-scf-dev-open')) { e.preventDefault(); isOpen() ? close() : open(); return; }
      if (t.hasAttribute('data-scf-dev-close')) { e.preventDefault(); close(); return; }
      if (t.hasAttribute('data-scf-dev-tab')) { e.preventDefault(); showFamily(t.dataset.scfDevTab); return; }
      if (t.hasAttribute('data-scf-dev-more')) {
        e.preventDefault();
        var fam = t.closest('.scf-dev__fam'), nowOpen = fam.classList.toggle('is-open');
        var was = t.textContent; t.textContent = t.dataset.less; t.dataset.less = was;
        if (!nowOpen) t.scrollIntoView({ block: 'nearest' });
        return;
      }
    }
    if (e.target.closest('.scf-dev__m') && Date.now() < guardUntil) { e.preventDefault(); return; }
    if (isOpen() && !e.target.closest('[data-scf-dev-pan], [data-scf-dev-open]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  /* Impulse re-renders the grid over AJAX; the panel is outside that region, so just make sure it is shut */
  document.addEventListener('collection:reloaded', close);
  /* older Safari has no :has(); mark the grid section that follows the line so its top padding drops */
  function mark() { var r = root(), sec = r && r.closest('.shopify-section'); if (sec && sec.nextElementSibling) sec.nextElementSibling.classList.add('scf-after-dev'); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
})();
